module.exports = __webpack_public_path__ + "static/media/german-word-for-white.d8a14361.jpg";